import { useEffect } from "react";
import { Play, Pause, SkipBack } from "lucide-react";
import { fmtTime } from "./courierMapUtils";

const SPEEDS = [1, 4, 10];

export const TrailPlayback = ({ points, idx, onIdx, playing, onPlaying, speed, onSpeed }) => {
  const n = points.length;
  useEffect(() => {
    if (!playing || n < 2) return;
    const t = setInterval(() => {
      onIdx((i) => {
        if (i >= n - 1) { onPlaying(false); return n - 1; }
        return i + 1;
      });
    }, 500 / speed);
    return () => clearInterval(t);
  }, [playing, speed, n, onIdx, onPlaying]);

  if (n < 2) return null;
  const cur = points[Math.min(idx, n - 1)];
  const pct = Math.round((idx / (n - 1)) * 100);
  return (
    <div data-testid="trail-playback" className="rounded-xl bg-white ring-1 ring-zinc-200 p-2.5 space-y-2">
      <div className="flex items-center gap-2">
        <button type="button" data-testid="playback-restart" aria-label="Od początku" onClick={() => { onIdx(0); onPlaying(false); }}
          className="w-8 h-8 rounded-full bg-zinc-100 hover:bg-zinc-200 flex items-center justify-center"><SkipBack className="w-3.5 h-3.5" /></button>
        <button type="button" data-testid="playback-toggle" aria-label={playing ? "Pauza" : "Odtwórz"}
          onClick={() => { if (!playing && idx >= n - 1) onIdx(0); onPlaying(!playing); }}
          className="w-9 h-9 rounded-full bg-zinc-900 text-white hover:bg-brand flex items-center justify-center transition-colors">
          {playing ? <Pause className="w-4 h-4" /> : <Play className="w-4 h-4 ml-0.5" />}
        </button>
        <div className="flex-1 min-w-0">
          <div className="flex items-center justify-between text-[10px] font-mono text-zinc-500">
            <span data-testid="playback-time" className="font-bold text-zinc-800">{fmtTime(cur?.ts)}</span>
            <span>{idx + 1}/{n} · {cur?.speed_kmh != null ? `${Math.round(cur.speed_kmh)} km/h` : "—"}</span>
          </div>
          <input type="range" min={0} max={n - 1} value={idx} onChange={(e) => { onIdx(Number(e.target.value)); onPlaying(false); }}
            data-testid="playback-slider" aria-label="Pozycja odtwarzania" className="w-full accent-[#E52C34] h-1.5" />
        </div>
      </div>
      <div className="flex items-center justify-between gap-2">
        <div className="flex rounded-full ring-1 ring-zinc-200 overflow-hidden text-[10px] font-bold">
          {SPEEDS.map((s) => (
            <button key={s} type="button" data-testid={`playback-speed-${s}`} onClick={() => onSpeed(s)}
              className={`px-2.5 h-7 ${speed === s ? "bg-zinc-900 text-white" : "bg-white text-zinc-600 hover:bg-zinc-100"}`}>{s}×</button>
          ))}
        </div>
        <div className="text-[10px] font-mono text-zinc-400">{pct}% przejazdu</div>
      </div>
    </div>
  );
};
